export const RD_CLIENT_ID = process.env.REACT_APP_RD_CLIENT_ID || '';
export const RD_CLIENT_SECRET = process.env.REACT_APP_RD_CLIENT_SECRET || '';

export async function sendLeadToRDStation(email: string, name: string) {
  if (!RD_CLIENT_ID || !RD_CLIENT_SECRET) {
    console.warn('RD Station credentials not found in environment variables. Webhook skipped.');
    return;
  }

  try {
    // 1. Get Access Token
    const authResponse = await fetch('https://api.rd.services/auth/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        client_id: RD_CLIENT_ID,
        client_secret: RD_CLIENT_SECRET,
        grant_type: 'client_credentials',
      }),
    });

    if (!authResponse.ok) throw new Error('Failed to authenticate with RD Station');
    const authData = await authResponse.json();
    const accessToken = authData.access_token;

    // 2. Send Conversion Event
    const conversionResponse = await fetch('https://api.rd.services/platform/conversions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        event_type: 'CONVERSION',
        event_family: 'CDP',
        payload: {
          conversion_identifier: 'cadastro_simulatoro',
          email: email,
          name: name,
        },
      }),
    });

    if (!conversionResponse.ok) throw new Error('Failed to send lead to RD Station');

    console.log('Lead successfully sent to RD Station!');
  } catch (error) {
    console.error('RD Station Integration Error:', error);
  }
}
